// extracted by mini-css-extract-plugin
module.exports = {"modal":"result-activate-account_modal__3UwCV","container":"result-activate-account_container__2HnF-"};